export class SlideDisplay
{
  public readonly mSlides: HTMLElement | null;
  public readonly mSlideItems: HTMLCollectionOf<HTMLElement>;

  private mCurrentSlide: number = 0;
  // setInterval()が返す値の型は、ブラウザとNode.js環境では異なる
  // （ブラウザではnumber、Node.jsではNodeJS.Timeout）
  private mIntervalId: number | NodeJS.Timeout | null;
  private readonly mChangeverTime: number;

  constructor(target_slides_id: HTMLElement | null, changeover_time: number = 5000)
  {
    // インスタンスが生成された時にスライド要素を初期化
    this.mSlides = target_slides_id;
    this.mSlideItems = this.mSlides?.getElementsByClassName('slide') as HTMLCollectionOf<HTMLElement>;
    // 最初のスライドのインディックスは0
    this.mCurrentSlide = 0;
    // setIntervalのIDを保持する変数。初期値はnull
    this.mIntervalId = null;
    this.mChangeverTime = changeover_time;
  }

  /**
   * // Method: スライドを初期化
   */
  private resetSlides(): void
  {
    if (this.mSlideItems)
    {
      // 全てのスライドから'is_active'クラスを削除し、z-indexを1に設定
      for (const slide of this.mSlideItems)
      {
        slide.classList.remove('is_active');
        slide.style.zIndex = '1';
      }
    }
  }

  /**
   * // Method: 指定されたインデックスのスライドを表示
   *
   * @param index スライドのインデックス
   */
  private showSlide(index: number = this.mCurrentSlide): void
  {
    // スライドを初期化
    this.resetSlides();

    if (this.mSlideItems)
    {
      // 指定されたインディックスのスライドを表示
      const slide: HTMLElement = this.mSlideItems[index];
      slide.classList.add('is_active');  // 'is_active' クラスを追加
      slide.style.zIndex = '2';          // z-indexを2に設定
    }
  }

  /**
   * // Method: 次のスライドを表示
   */
  private nextSlide(): void
  {
    if (this.mSlideItems)
    {
      // 現在のスライドインディックスを更新し、スライドショーを表示
      this.mCurrentSlide = (this.mCurrentSlide + 1) % this.mSlideItems.length;
    }
    this.showSlide(this.mCurrentSlide);
  }

  /**
   * // Method: 自動スライドショーを開始
   */
  public startAutoSlide(): void
  {
    this.showSlide(); // 初回表示
    // 指定した時間ごとに次のスライドに切り替える
    this.mIntervalId = setInterval(() => this.nextSlide(), this.mChangeverTime);
  }
}
